if (!customElements.get('shoppable-social')) {
  class ShoppableSocial extends HTMLElement {
    constructor() {
      super();

      this.initSlider();
    }

    initSlider() {
      var swiperArea = this.querySelector('.swiper');
      this.slider = new Swiper(swiperArea, {
        slidesPerView: 1.1,
        autoplay: true,
        loop: true,
        spaceBetween: 14,
        pagination: {
          el: ".shoppable__social-pagination",
        },
        breakpoints: {
          640: {
            spaceBetween: 14,
            slidesPerView: 2
          },
          750: {
            spaceBetween: 20,
            slidesPerView: 3
          },
          990: {
            spaceBetween: 20,
            slidesPerView: 4
          }
        }
      });
    }
  }

  customElements.define('shoppable-social', ShoppableSocial);
}
